import { Trans } from 'react-i18next';
import PeopleSection1Image1 from '../../assets/people_section1_image1.svg';
import PeopleSection1Image1Mobile from '../../assets/people_section1_image1_mobile.svg';
import PeopleSection1Image2 from '../../assets/people_section1_image2.svg';
import PeopleSection1Image2Mobile from '../../assets/people_section1_image2_mobile.svg';
import PeopleSection1Image3 from '../../assets/people_section1_image3.svg';
import PeopleSection1Image3Mobile from '../../assets/people_section1_image3_mobile.svg';
import theme from '../../common/color/theme';
import { CenterLayout, HorizontalEqualLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H3, H7, Point2, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const OurPeopleSection1 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : pxToRem(80)} />
      <H3>Our People</H3>
      <BTBox height={pxToRem(110)} />
      <CenterLayout>
        <H7 style={{
          textAlign: 'center',
          ...isMobile ? { paddingLeft: '24px', paddingRight: '24px' } : {}
        }}><Trans i18nKey='우리는 정직함과 열정, 그리고 끝없는 성장의지를 가진 사람들과 함께 하고 싶습니다.' /></H7>
      </CenterLayout>
      <BTBox height={isMobile ? 46 : pxToRem(110)} />
      <HorizontalEqualLayout
        gap={pxToRem(isEng ? 40 : 5)}
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'start',
        }}
      >
        <VerticalLayout style={{ alignItems: 'center', width: isMobile ? '100%' : undefined }}>
          <Point2 style={{ color: theme.colors.BIBI }}><Trans i18nKey='주도성' /></Point2>
          <BTBox height={3} />
          <H7 style={{ textAlign: 'center',
            ...isEng ? {height: isMobile ? '56px' : pxToRem(240)} : {}
           }}><Trans i18nKey='스스로 목표를 세우고 실행하는 사람' /></H7>
          <BTBox height={isMobile ? 8 : pxToRem(89)} />
          <img src={isMobile ? PeopleSection1Image1Mobile : PeopleSection1Image1} style={isMobile ? { width: '280px', height: '208px' } : { width: pxToRem(400), height: pxToRem(300) }} />
          <BTBox height={isMobile ? 8 : pxToRem(89)} />
          <Text4 style={{ textAlign: 'center', opacity: '0.5' }}>
            <Trans i18nKey={"누구보다 먼저 현장을 이해하고, 문제를 정의하며, 능동적으로 해결 방안을 찾아 실행하는 사람을 우리는 주도적인 인재라 부릅니다."} />
          </Text4>
          {isMobile && (
            <>
              <BTBox height={60} />
              <div style={{ width: '100%', height: '1px', backgroundColor: 'black', opacity: 0.2 }}></div>
              <BTBox height={60} />
            </>
          )}
        </VerticalLayout>

        <VerticalLayout style={{ alignItems: 'center', width: isMobile ? '100%' : undefined }}>
          <Point2 style={{ color: theme.colors.BIBI }}><Trans i18nKey='안전의식' /></Point2>
          <BTBox height={3} />
          <H7 style={{ textAlign: 'center',
            ...isEng ? {height: isMobile ? '56px' : pxToRem(240)} : {}
           }}><Trans i18nKey='나와 동료의 안전을 지키는 책임 있는 사람' /></H7>
          <BTBox height={isMobile ? 8 : pxToRem(89)} />
          <img src={isMobile ? PeopleSection1Image2Mobile : PeopleSection1Image2} style={isMobile ? { width: '280px', height: '160px' } : { width: pxToRem(400), height: pxToRem(300) }} />
          <BTBox height={isMobile ? 8 : pxToRem(89)} />
          <Text4 style={{ textAlign: 'center', opacity: '0.5' }}>
            <Trans i18nKey={"작은 위험도 먼저 인지하고, 모든 업무에 있어 안전을 최우선의 가치로 삼는 사람이 비비테크의 기준입니다."} />
          </Text4>
          {isMobile && (
            <>
              <BTBox height={60} />
              <div style={{ width: '100%', height: '1px', backgroundColor: 'black', opacity: 0.2 }}></div>
              <BTBox height={60} />
            </>
          )}
        </VerticalLayout>

        <VerticalLayout style={{ alignItems: 'center', width: isMobile ? '100%' : undefined }}>
          <Point2 style={{ color: theme.colors.BIBI }}><Trans i18nKey='실행력' /></Point2>
          <BTBox height={3} />
          <H7 style={{ textAlign: 'center',
            ...isEng ? {height: isMobile ? '56px' : pxToRem(240)} : {}
           }}><Trans i18nKey='생각에 머물지 않고, 끝까지 실천하는 사람' /></H7>
          <BTBox height={isMobile ? 8 : pxToRem(89)} />
          <img src={isMobile ? PeopleSection1Image3Mobile : PeopleSection1Image3} style={isMobile ? { width: '280px', height: '208px' } : { width: pxToRem(400), height: pxToRem(300) }} />
          <BTBox height={isMobile ? 8 : pxToRem(89)} />
          <Text4 style={{ textAlign: 'center', opacity: '0.5' }}>
            <Trans i18nKey={"문제를 발견하면 곧장 움직이고, 아이디어를 실제 결과로 완성하는 현장의 실천가를 우리는 신뢰합니다."} />
          </Text4>
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 222 : pxToRem(211)} />
    </VerticalLayout>
  );
};

export default OurPeopleSection1;
